export default __webpack_public_path__ + "static/media/x.f641b0c6.svg";